import "./Markets.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import RegionalReach from "./sections/RegionalReach";
import OurStewardshipPledge from "./sections/OurStewardshipPledge";
import CuratedForStorytellers from "./sections/CuratedForStorytellers";
import CtaFooterSection from "./sections/CtaFooterSection";
import Footer from "@/reusable_sections/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
export default function MarketsPage() {
  return <div>
      <FraternalExcellenceHeader />
      <RegionalReach />
      <OurStewardshipPledge />
      <CuratedForStorytellers />
      
      

      <CtaFooterSection />
      <Footer />
    </div>;
}